<template>
  <el-container>
    <el-main style="padding:0;margin-left: 30px;width:100vh">
      <vm-table
          ref="vmTable"
          height="64vh"
          :filter.sync="filter"
          module="basic"
          url="workflowDistributeConfigs"
          @select="selectTest"
          @select-all="selectAll">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.editWFDistributeConfig.open(0)">新建</el-button>
          <el-button type="danger" @click="deleteIds">批量删除</el-button>
          <el-button type="primary" @click="exportExcel">导出</el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="待授权节点节点">
              <el-input v-model.trim="filter.workflowNodeName" clearable/>
            </vm-search>
            <vm-search label="待授权角色">
              <el-input v-model.trim="filter.roleName" clearable/>
            </vm-search>
            <vm-search label="待授权用户">
              <el-input v-model.trim="filter.employeeName" clearable/>
            </vm-search>
            <vm-search label="对应处理角色">
              <el-input v-model.trim="filter.approverRoleName" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" align="center" width="55"/>
        <el-table-column prop="billType" align="center" label="流程名称">
          <template slot-scope="scope">
            <span>{{scope.row.billType ===1 ? "eMES销售订单":"SAP销售订单"}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="workflowNodeName" align="center" label="待授权节点"/>
        <el-table-column prop="roleName" align="center" label="待授权角色"/>
        <el-table-column prop="userName" align="center" label="待授权用户"/>
        <el-table-column prop="approverRoleName" align="center" label="对应处理角色"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button type="info" @click="$refs.editWFDistributeConfig.open(scope.row.wdcid)">编辑</el-button>
            <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
      <w-f-distribute-config-edit ref="editWFDistributeConfig" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import WFDistributeConfigEdit from "@/views/SystemInfo/WFDistributeConfig/WFDistributeConfigEdit";

  export default {
    name: "WFDistributeConfigList",
    components: {WFDistributeConfigEdit, VmTable,VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          flowName: "",
          workflowNodeName: "",
          roleName: "",
          employeeName: "",
          approverRoleName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.wdcid);
          }
          this.$http
            .delete("basic","workflowDistributeConfigs/deleteByIds",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","workflowDistributeConfigs",row.wdcid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      //导出
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","workflowDistributeConfigs/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style scoped>

</style>
